// eslint-disable-next-line import/prefer-default-export
export const oldSystemFeatures = [
  {
    feature: 'Dispatch',
    link: '/features/dispatch-software',
  },
  {
    feature: 'Customer Service',
    link: '/features/customer-experience-software',
  },
  {
    feature: 'Sales',
    link: '/features/call-booking-software',
  },
  {
    feature: 'Marketing',
    link: '/features/home-services-marketing-software',
  },
  {
    feature: 'Payments',
    link: '/features/payments',
  },
  {
    feature: 'Payroll',
    link: '/features/contractor-payroll-software',
  },
  {
    feature: 'Equipment',
    link: '/features/job-costing-software',
  },
  {
    feature: 'Agreements',
    link: '/features/service-agreement-software',
  },
  {
    feature: 'Accounting',
    link: '/features/field-service-management-software-quickbooks',
  },
  {
    feature: 'Inventory',
    link: '/field-service-management-software',
  },
  {
    feature: 'Scheduling',
    link: '/features/service-scheduling-software',
  },
  {
    feature: 'Reporting',
    link: '/features/field-reporting-software',
  },
];

export const newSystemFeatures = [
  {
    title: 'Call Booking',
    description:
      'The ServiceTitan phone integration enables your team to book more jobs while providing a highly polished customer experience.',
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/228NcMsm5Hx7r6EQsGaFWn/45b0ac4a9d7a753ac42ec2896d1ada10/call_booking.svg',
    link: 'https://www.servicetitan.com/call-booking-software',
  },
  {
    title: 'Marketing',
    description:
      "ServiceTitan's marketing scorecard allows you to monitor, adjust, and even create new campaigns with just a few clicks.",
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/42X2Dpl7xNvqDpFavldiKq/ec5e1b140312bfbf4db729b28067ce01/Marketing.svg',
    link: 'https://www.servicetitan.com/home-services-marketing-software',
  },
  {
    title: 'Payments',
    description:
      'Capture checks and credit cards in the field or send customers a link to a personalized online payment portal.',
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/77ONRKUOovkCz8pNfO5fta/f37a60e6d19dc411a63eb86625fe751c/Payments.svg',
    link: 'https://www.servicetitan.com/payments',
  },
  {
    title: 'Payroll',
    description:
      'Master your payroll with ServiceTitan’s integrated processing tools and use real-time timesheet tracking, and more.',
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/2VYUXgV122raWyU4tdHQuY/7441b7a500084d73a63e4a124d7c55ab/payroll.svg',
    link: 'https://www.servicetitan.com/contractor-payroll-software',
  },
  {
    title: 'Job Costing',
    description:
      'Identify potential risks early to deliver on-time and within budget for every type of job.',
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/7yJWCJLIgVw95Pj8nMbkFW/553501abd881e2ee571a7e2acb8bd691/job_costing.svg',
    link: 'https://www.servicetitan.com/job-costing-software',
  },
  {
    title: 'Customer Financing',
    description:
      'Provide customer financing in ServiceTitan, receive instant approval so the job gets finished faster.',
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/2TyzZR08sl5GaqVCfEw5BO/fdb46346287b8fadc1c70c7245a90f7a/Accounting.svg',
    link: 'https://www.servicetitan.com/customer-financing',
  },
  {
    title: 'Accounting',
    description:
      "Our QuickBooks integration lets you use leading, time-saving accounting tools for your company's day-to-day transactions.",
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/352RZgd2O6zYX6BAtHeLzR/5322bb50099f3fb3cb5b4c53864f491f/quickbooks.svg',
    link: 'https://www.servicetitan.com/field-service-management-software-quickbooks',
  },
  {
    title: 'Scheduling',
    description:
      'Dispatchers can see where each tech is in the job cycle—in real time. Queue up new jobs and adjust capacity easily.',
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/gyHHYRUUFADS3Y8bwvN8k/d1f4b6416a01a23a9b674dbaa9570eff/Scheduling.svg',
    link: 'https://www.servicetitan.com/service-scheduling-software',
  },
  {
    title: 'Reporting',
    description:
      'ServiceTitan’s dynamic dashboard can be tailored to display the metrics and KPIs that mean the most to your business.',
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/xUS0KjjUv2AXDfzJWlp0M/68d9ade2fb8a54cd9563c76c78762269/Reporting.svg',
    link: 'https://www.servicetitan.com/field-reporting-software',
  },
  {
    title: 'Dispatching',
    description:
      'With intelligent scheduling, ServiceTitan makes it easy for dispatchers to keep your team flexible and proactive all day long.',
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/6tTdOgHJ9xDg1Jq4jhkJIT/4db83d528d013662082f5283e2c557c1/Dispatch.svg',
    link: 'https://www.servicetitan.com/dispatch-software',
  },
  {
    title: 'Customer Service',
    description:
      'Offer a five-star customer experience using on-demand features that will also help boost your reputation.',
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/2ltweWf2QuX4vzOBKyp4EH/5f490589dee34fdd87118ebd0fb44ebb/Customer_Service.svg',
    link: 'https://www.servicetitan.com/customer-experience-software',
  },
  {
    title: 'Memberships',
    description:
      'Assign equipment installs directly to customer contracts so regular maintenance visits are clear, trackable, and error-free.',
    icon:
      'https://images.ctfassets.net/3q1a0w8cwuwf/5eCVq5Ao5J3MypQ30oPkJJ/1cfb6eae944dac492296ba36e4e331b2/Agreements.svg',
    link: 'https://www.servicetitan.com/service-agreement-software',
  },
];
